const LANG_JA = 'ja'
const LANG_CN = 'cn'

export default {
  LANG_JA,
  LANG_CN
}
